/* eslint-disable no-nested-ternary */
import { css } from 'styled-components';
import { themeGet } from '@styled-system/theme-get';

export const StaticBackgroundOverflowWrapperStyles = css`
  &.static-with-background-overflow {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;

    @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
      min-height: 335px;
      flex-direction: column;
    }

    @media only screen and (min-width: ${themeGet('breakpoints.xlg')}) {
      min-height: 475px;
    }
  }
`;

export const StaticBackgroundOverflowContentStyles = css`
  ${StaticBackgroundOverflowWrapperStyles}.static-with-background-overflow & {
    margin: 40px auto;
    padding: ${props => (props.bgColorWidth === false ? '0 1.25rem' : '0')};

    @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
      width: 100%;
    }

    @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
      padding: ${props =>
        props.bgColorWidth === false ? '0 1rem 0 3.75rem' : '0 2rem'};
    }
  }
`;

export const StaticBackgroundOverflowHeadingStyles = css`
  ${StaticBackgroundOverflowWrapperStyles}.static-with-background-overflow & {
    @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
      max-width: 50%;
    }
  }
`;

export const StaticBackgroundOverflowIntroStyles = css`
  ${StaticBackgroundOverflowWrapperStyles}.static-with-background-overflow & {
    max-width: none;
    margin: 0;

    @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
      max-width: 50%;
    }
  }
`;

export const StaticBackgroundOverflowMediaContainerStyles = css`
  ${StaticBackgroundOverflowWrapperStyles}.static-with-background-overflow & {
    margin: 0 auto 40px;
    text-align: center;
    background-image: ${props =>
      props.assetPosition === true && props.bgImage
        ? `url(${props.bgImage})`
        : null};
    background-size: ${props => (props.bgImage ? 'contain' : null)};
    background-position: ${props =>
      props.assetPosition === true ? 'center' : null};
    background-repeat: ${props =>
      props.assetPosition === true ? 'no-repeat' : null};

    @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
      text-align: right;
      width: 50%;
      margin: 0;
      background-size: ${props => (props.bgImage ? 'contain' : null)};
      background-position: ${props =>
        props.assetPosition === true ? 'right center' : null};
      position: absolute;
      right: -1%;
    }

    @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
      background-size: ${props => (props.bgImage ? 'contain' : null)};
      right: -2%;
    }
  }
`;

export const StaticBackgroundOverflowHeroImageStyles = css`
  ${StaticBackgroundOverflowWrapperStyles}.static-with-background-overflow & {
    height: auto;
    margin: auto;

    @media only screen and (min-width: 414px) {
      width: 372px;
      height: 367px;
    }

    @media only screen and (min-width: ${themeGet('breakpoints.xlg')}) {
      width: 522px;
      height: 515px;
    }
  }
`;
